import { useAmplitudeContext } from '@/analytics/amplitudeProvider';
import { useCallback } from 'react';

type EventNameProperties = {
  lessonStarted: { embaUserAttendanceSlug: string; lessonSlug: string };
  lessonCompleted: { embaUserAttendanceSlug: string; lessonSlug: string };
  lessonOpenedFromList: {
    embaUserAttendanceSlug: string;
    lessonSlug: string;
    isSkipped: boolean;
  };
};

// イベント名の型 (例: 'lessonStarted' | 'lessonCompleted' | ...)
type AmplitudeEventName = keyof EventNameProperties;

// イベント名に対応するプロパティ型を取り出すための型
type AmplitudeEventProperties<T extends AmplitudeEventName> =
  EventNameProperties[T];

export const useAmplitudeLogEvent = () => {
  const { amplitude } = useAmplitudeContext();

  const trackAmplitudeLogEvent = useCallback(
    <EventName extends AmplitudeEventName>(
      eventName: EventName,
      eventProperties: AmplitudeEventProperties<EventName>,
    ) => {
      amplitude.track(eventName, eventProperties);
    },
    [amplitude],
  );

  return trackAmplitudeLogEvent;
};
